import { filter } from 'rxjs/operators';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AuthenticationService } from '../login/login.service';
import { UnreadMessagesService } from './unread-messages/unread-messages.service';
import { AppSettings } from '../common/config';
import {
  NSS_SUPPORT_STEP1_VISIBILITY_SVG,
  NSS_SUPPORT_STEP1_WEBSITE_SVG,
  NSS_SUPPORT_STEP1_CAPACITY_SVG,
} from '../dashboard/servicesComponets/supportRequest/home/home-icons';
import { SupportRequestWizardService } from '../dashboard/servicesComponets/supportRequest/shared/support-request-wizard.service';
import { SR_ROUTES } from '../dashboard/servicesComponets/supportRequest/shared/support-request-utils';

@Component({
  selector: 'smart-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  inDashboardRoute = false;
  isOnSupportRoute = false;

  AppSettings = AppSettings;

  homeLinkDisable!: boolean;

  readonly supportNavIcons: { visibility: SafeHtml; website: SafeHtml; capacity: SafeHtml };

  @Output() showSendMessage: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public authService: AuthenticationService,
    private unreadMessagesService: UnreadMessagesService,
    private router: Router,
    private wizard: SupportRequestWizardService,
    sanitizer: DomSanitizer
  ) {
    const toNavSvg = (svg: string): SafeHtml =>
      sanitizer.bypassSecurityTrustHtml(
        svg
          .replace(/\swidth="[^"]*"/, ' width="22"')
          .replace(/\sheight="[^"]*"/, ' height="22"')
          .replace(/fill="#[^"]*"/g, 'fill="currentColor"')
      );

    this.supportNavIcons = {
      visibility: toNavSvg(NSS_SUPPORT_STEP1_VISIBILITY_SVG),
      website: toNavSvg(NSS_SUPPORT_STEP1_WEBSITE_SVG),
      capacity: toNavSvg(NSS_SUPPORT_STEP1_CAPACITY_SVG),
    };

    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      const url = event.url;
      this.inDashboardRoute = this.router.routerState.snapshot.url.startsWith('/dashboard');
      this.isOnSupportRoute = url.startsWith('/dashboard/support-request');

      // Disable home link on home page and update message count
      if (url === '/') {
        this.homeLinkDisable = true;
      } else if (url === '/dashboard') {
        this.unreadMessagesService.refreshUnreadMessages();
      } else {
        this.homeLinkDisable = false;
      }
    });
  }

  ngOnInit() {
    this.unreadMessagesService.refreshUnreadMessages();
  }

  onSendMessageClick() {
    this.showSendMessage.emit();
  }

  goToSupportRequest(category: string): void {
    this.wizard.setCategory(category);
    this.router.navigate([SR_ROUTES.step2]);
  }

  /**
   * Returns `true` when the current URL is within the support-request sub-tree
   * and the wizard's active category matches one of the supplied values.
   *
   * Used to highlight the correct side-nav item without relying on
   * `routerLinkActive`, which cannot distinguish between the three survey
   * types that all share the same `/dashboard/support-request` route prefix.
   */
  isActiveSupportCategory(...cats: string[]): boolean {
    return this.isOnSupportRoute && cats.includes(this.wizard.category ?? '');
  }
}
